export interface ResponseState {
    renderedAt: number; // Timestamp when server rendered his response
}

export default function response(state: ResponseState = { renderedAt: null }, action: any) {
    return state;
}

export const getRenderedAt = (state: ResponseState) => state.renderedAt;
